import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import SVGWrapper from '../../SVGWrapper/index.js';

var children = {
    plus: function (color) { return (React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M12.6667 7.99998C12.6667 8.36817 12.3682 8.66665 12 8.66665H8.66667V12C8.66667 12.3682 8.36819 12.6666 8 12.6666C7.63181 12.6666 7.33333 12.3682 7.33333 12V8.66665H4C3.63181 8.66665 3.33333 8.36817 3.33333 7.99998C3.33333 7.63179 3.63181 7.33331 4 7.33331H7.33333V3.99998C7.33333 3.63179 7.63181 3.33331 8 3.33331C8.36819 3.33331 8.66667 3.63179 8.66667 3.99998V7.33331H12C12.3682 7.33331 12.6667 7.63179 12.6667 7.99998Z", fill: color })); },
    minus: function (color) { return (React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M12 7.99998C12 8.36817 11.7015 8.66665 11.3333 8.66665H4.66667C4.29848 8.66665 4 8.36817 4 7.99998C4 7.63179 4.29848 7.33331 4.66667 7.33331H11.3333C11.7015 7.33331 12 7.63179 12 7.99998Z", fill: color })); },
};
var iconSize = {
    large: 32,
    medium: 24,
    small: 16,
};
function Mathematics(_a) {
    var styleType = _a.styleType, size = _a.size, _b = _a.color, color = _b === void 0 ? '#212529' : _b, onClick = _a.onClick, style = _a.style, props = __rest(_a, ["styleType", "size", "color", "onClick", "style"]);
    return (React.createElement(SVGWrapper, __assign({ width: iconSize[size], height: iconSize[size], ratio: {
            x: iconSize[size] / iconSize.small,
            y: iconSize[size] / iconSize.small,
        }, onClick: onClick, style: style }, props), styleType && children[styleType](color)));
}

export { Mathematics as default };
